<template>
  <div class="home">
    <home-header activeIndex="1" :isShow="true"></home-header>
    <div class="deepread-wrap">
      <div class="deepread-wrap-container">
        <!-- 深度阅读 -->
        <div class="deepread">
          <title-bar
            :to="{ path: '/pastbook', meta: { type: 1 } }"
            title="深度阅读"
          ></title-bar>
          <div class="deepread-main">
            <div class="deepread-main-cover">
              <img :src="deepread.image" alt="img" class="cover-img" />
            </div>
            <div class="deepread-main-content">
              <div class="deepread-main-content-title">
                {{ deepread.title }}
              </div>
              <div class="author">作者：{{ deepread.author }}</div>
              <div class="intro">
                {{ deepread.intro }}
              </div>
              <div class="nav">
                <div
                  @click="
                    navToByValit({
                      path: '/deepread',
                      query: { tab: 0, id: deepread.id },
                    })
                  "
                  class="nav-item"
                >
                  <img
                    class="nav-item-img"
                    src="../../assets/images/leadership.png"
                    alt=""
                  />
                  <span class="nav-item-name">思维导读</span>
                </div>
                <div class="tag"></div>
                <div
                  @click="
                    navToByValit({
                      path: '/deepread',
                      query: { tab: 1, id: deepread.id },
                    })
                  "
                  class="nav-item"
                >
                  <img
                    class="nav-item-img"
                    src="../../assets/images/depth_apprect.png"
                    alt=""
                  />
                  <span class="nav-item-name">深度赏析</span>
                </div>
                <div class="tag"></div>
                <div
                  @click="
                    navToByValit({
                      path: '/deepread',
                      query: { tab: 2, id: deepread.id },
                    })
                  "
                  class="nav-item"
                >
                  <img
                    class="nav-item-img"
                    src="../../assets/images/know_ext.png"
                    alt=""
                  />
                  <span class="nav-item-name">知识延伸</span>
                </div>
              </div>
              <div class="deepread-main-content-btns">
                <el-button class="btn_style" @click="navToEpubRead" type="primary"
                  >立即阅读</el-button
                >
                <el-button
                  class="btn btn_style"
                  @click="collect"
                  :plain="false"
                  :type="is_collect ? 'info' : 'primary'"
                >
                  {{ is_collect ? "已收藏" : "加入收藏" }}</el-button
                >
              </div>
            </div>
            <!-- 热门评论 -->
            <div class="deepread-main-sidebar">
              <div class="sidebar-title">
                <img class="hot" src="../../assets/images/hot.png" alt="hot" />
                <div class="title-text">
                  热门评论...................................................................................................
                </div>
                <div @click="navToMore" class="more">(查看更多)</div>
              </div>
              <div class="sidebar-content">
                <div
                  class="sidebar-content-row"
                  v-for="(item, index) in deepReadCommentList"
                  :key="index"
                >
                  <span class="name">{{ item.nickname }}：</span>
                  <span class="">{{ item.content }}</span>
                </div>
                <div class="none" v-if="deepReadCommentList.length == 0">
                  <span>暂无记录</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-container">
      <!-- 活动 -->
      <div class="activity">
        <title-bar
          :to="{ path: '/activity/undefined', meta: { type: 0 } }"
          title="深度阅读"
        >
          <div class="nav activity-nav">
            <div
              @click="navChange(index)"
              class="nav-item nav-item_gray"
              :class="{ 'nav-item_green': item.isActive }"
              v-for="(item, index) in activityNavs"
              :key="index"
            >
              {{ item.name }}
            </div>
            <div @click="navToAwardWork" to="/awardWorks" class="awardwork">
              <i class="icon"
                ><svg
                  t="1629161155898"
                  class="icon"
                  viewBox="0 0 1185 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="8987"
                  width="64"
                  height="64"
                >
                  <path
                    d="M564.951579 988.698947a285.345684 285.345684 0 1 1 285.345684-285.345684A286.369684 286.369684 0 0 1 564.951579 988.698947z m0-507.957894a222.612211 222.612211 0 1 0 222.61221 222.61221 223.474526 223.474526 0 0 0-222.61221-222.61221z"
                    fill="#FFB463"
                    p-id="8988"
                  ></path>
                  <path
                    d="M655.872 490.145684h-241.448421L232.582737 110.753684h241.448421z m-197.551158-62.706526h100.325053l-122.287158-253.978947h-100.298105z"
                    fill="#FFB463"
                    p-id="8989"
                  ></path>
                  <path
                    d="M687.211789 490.145684h-191.326315a31.366737 31.366737 0 1 1 0-62.706526h150.501052l122.287158-253.978947h-100.271158l-81.515789 172.463157a30.881684 30.881684 0 0 1-56.42779-25.088l100.325053-206.955789h241.448421z"
                    fill="#FFB463"
                    p-id="8990"
                  ></path>
                  <path
                    d="M564.951579 838.224842a137.970526 137.970526 0 1 1 137.970526-137.970526 135.248842 135.248842 0 0 1-137.970526 137.970526z m0-213.207579a75.264 75.264 0 1 0 75.264 75.264 76.288 76.288 0 0 0-75.264-75.290947z"
                    fill="#FFB463"
                    p-id="8991"
                  ></path></svg
              ></i>
              <span class="text">获奖作品</span>
            </div>
            <div class="nav-subtitle">Activities</div>
          </div>
        </title-bar>
        <div class="activity-main">
          <activity-item
            class="item"
            v-for="(item, index) in activityList"
            :key="index"
            :obj="item"
          ></activity-item>
          <data-empty v-show="activityList.length == 0"></data-empty>
        </div>
      </div>
      <!-- 每周新语 -->
      <div class="newwords">
        <title-bar
          :to="{ path: '/greenwrite', meta: { type: 5 } }"
          subtitle="Weekly new words"
          title="每周新语"
        ></title-bar>
        <div class="newwords-list">
          <newwords-item
            @tab="
              navToByValit({
                path: '/greenwritedetail',
                query: { id: item.id },
              })
            "
            class="newwords-list-item"
            v-for="(item, index) in qqwrite"
            :key="index"
            :obj="item"
          ></newwords-item>
        </div>
      </div>
      <!-- 视频讲堂 -->
      <div class="lecture">
        <title-bar
          :to="{ path: '/videonote', meta: { type: 3 } }"
          subtitle="Video lecture hall"
          title="视频讲堂"
        ></title-bar>
        <div class="lecture-list">
          <lecture-item
            @tab="navToByValit({ path: '/notedetail', query: { id: item.id } })"
            class="lecture-list-item"
            v-for="(item, index) in videoclass"
            :key="index"
            :obj="item"
          ></lecture-item>
        </div>
      </div>
      <!-- 每周新声 -->
      <div class="newvoice">
        <title-bar
          :to="{ path: '/greenlisten', meta: { type: 4 } }"
          subtitle="Weekly new voice"
          title="每周新声"
        ></title-bar>
        <div class="newvoice-list">
          <newvoice-item
            class="newvoice-list-item"
            v-for="(item, index) in qqlisten"
            :key="index"
            :obj="item"
            :authority="authority"
          ></newvoice-item>
        </div>
      </div>
      <!-- 有知 -->
      <div class="knowledge">
        <title-bar
          :to="{ path: '/knowing', meta: { type: 2 } }"
          subtitle="Knowledge"
          title="有知"
        ></title-bar>
        <div class="knowledge-list">
          <knowledge-item
            @tab="
              navToByValit({ path: '/knowingdetail', query: { id: item.id } })
            "
            class="knowledge-list-item"
            v-for="(item, index) in youzhi"
            :key="index"
            :obj="item"
          ></knowledge-item>
        </div>
      </div>
      <!-- 活跃举办方 -->
      <div class="active-origanizer">
        <title-bar
          :showmore="false"
          subtitle="Active Organizer"
          title="活跃举办方"
        ></title-bar>
        <div class="list">
          <active-origanizer></active-origanizer>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
// import HomeFooter from "@/components/Footer";
import HomeFooter from "@/components/HomeFooter.vue";

import titleBar from "./components/titleBar.vue";
import ActivityItem from "./components/activityItem.vue";
import NewwordsItem from "./components/newwordsItem.vue";
import LectureItem from "./components/lectureItem.vue";
import NewvoiceItem from "./components/newvoiceItem.vue";
import KnowledgeItem from "./components/knowledgeItem.vue";
import ActiveOriganizer from "./components/activeOriganizer.vue";
import DataEmpty from "@/components/Data";

export default {
  components: {
    HomeHeader,
    HomeFooter,
    titleBar,
    ActivityItem,
    NewwordsItem,
    LectureItem,
    NewvoiceItem,
    KnowledgeItem,
    ActiveOriganizer,
    DataEmpty,
  },
  props: {},
  data() {
    return {
      activityNavs: [
        { name: "本馆活动", isActive: true },
        { name: "其他活动", isActive: false },
      ],
      homeData: "",
      deepread: "",
      is_collect: false,
      qqlisten: "",
      qqwrite: "",
      videoclass: "",
      youzhi: "",
      deepReadCommentList: [],
      group: "pc",
      activityList: [],
      ogran_id: "",
      agencyId: "", //机构id
      authority: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    navToMore() {
      if (this.authority.includes("深度阅读")) {
        // type 1 控制是否锚点定位
        this.$router.push({
          path: "/deepread",
          query: { tab: 0, id: this.deepread.id, type: 1 },
        });
      } else {
        this.$message.closeAll();
        this.$message({
          // message: "暂无权限",
          message: "暂无权限,请与图书馆联系",
          offset: 400,
          type:'warning'
        });
      }
    },
    navChange(index) {
      console.log("el");
      let nav_el = document.querySelector(".activity-nav");
      this.activityNavs.forEach((item, el_index) => {
        console.log("foreach", index, el_index);
        if (index == el_index) {
          item.isActive = true;
        } else {
          item.isActive = false;
        }
      });
      // item.isActive = true;

      if (index == 1) {
        this.getActivitybyOther(1, 3);
        nav_el.style.setProperty("--navx", 106 + 50);
      } else {
        this.getActivitybyOur(1, 3);
        nav_el.style.setProperty("--navx", 0);
      }
    },
    // 获取首页数据
    async getHome(id) {
      try {
        console.log("gethome", this.organ_id);

        let res = await this.$api.getHome({
          params: {
            // ogran_id: this.ogran_id,
            ogran_id: id,
            group: "pc",
          },
          data: {},
        });
        // console.log("gethome", this.organ_id);
        this.homeData = res.data;
        this.deepread = res.data.deepread;
        this.is_collect = res.data.is_collect;
        this.qqlisten = res.data.qqlisten;
        this.qqwrite = res.data.qqwrite;
        this.videoclass = res.data.videoclass.slice(0, 3);
        this.youzhi = res.data.youzhi;
        this.getDeepreadComment(this.deepread.id, 1);
      } catch (error) {
        console.log("error", error);
      }
    },
    // 获取深度阅读得评论
    async getDeepreadComment(id, page) {
      try {
        let res = await this.$api.getDeepReadComment({
          params: {
            page: page,
            "per-page": 10,
          },
          data: {
            source_id: id,
          },
        });
        this.deepReadCommentList = res.data.slice(0, 7);
      } catch (error) {}
    },
    // 跳转电子书阅读
    navToEpubRead() {
        let routeData;
        let external_url;
        if(this.deepread.is_type==1){
          let href = "https://www.yulin365.net/book/#/ebook?url=" + this.deepread.url;
          window.open(href, "_blank");
        }else if(this.deepread.is_type==2){
            external_url =  this.deepread.external_url
            sessionStorage.setItem("BOOK_DATA", external_url)
            routeData = this.$router.resolve({
              path: "/epub-read",
            });
            window.open(routeData.href, "_blank");
            /** href = "https://reader.keledgechain.com/web/#/epubReader?"+
                "AppId="+external_url.kcAppId+
                "&ContentId="+external_url.externalId+
                "&SkuId="+external_url.externalSkuExId+
                "&DataFileId="+external_url.externalDataFileEpubId+
                "&Extra="+external_url.kcExtra+
                "&FileFormat=epub";**/

        }else if(this.deepread.is_type==3){
            external_url =  this.deepread.external_url
            sessionStorage.setItem("BOOK_DATA", external_url)
            routeData = this.$router.resolve({
              path: "/pdf-read",
            });
            window.open(routeData.href, "_blank");
            /**external_url =  JSON.parse(this.deepread.external_url);
            href = "https://reader.keledgechain.com/web/#/pdfReader?"+
                "AppId="+external_url.kcAppId+
                "&ContentId="+external_url.externalId+
                "&SkuId="+external_url.externalSkuExId+
                "&DataFileId="+external_url.externalDataFilePdfId+
                "&Extra="+external_url.kcExtra+
                "&FileFormat=epub";**/
        }
    },
    // 获取本馆活动
    getActivitybyOur(page, pageSize) {
      let data = {
        group: this.group,
        page: page,
        page_size: pageSize,
        organ_id: localStorage.getItem("ogran_id"),
      };
      this.$api.activityOwn(data).then((res) => {
        this.activityList = res.data.activity_list.slice(0, 3);
      });
    },
    // 获取其他活动
    getActivitybyOther(page, pageSize) {
      let data = {
        keywords: "",
        status: "",
        type: "",
        province: "",
        page: page,
        page_size: pageSize,
      };
      this.$api.activityList(data).then((res) => {
        this.activityList = res.data.activity_list;
      });
    },
    getUrl() {
      let url = this.$route.query.redirect;
      console.log(url);
      this.$router.push({
        path: url,
      });
    },

    // 收藏书籍
    async collectionBooks() {
      this.$message.closeAll();
      try {
        let token = localStorage.getItem("token");
        let id = this.deepread.id;
        let res = await this.$api.collectDeepred({
          params: {
            "access-token": token,
            id: id,
          },
          data: {},
        });
        this.is_collect = true;
        this.$message({
          message: "收藏成功",
          type: "success",
        });
      } catch (error) {
        console.log("---err", error);
      }
    },
    // 取消收藏
    async cancelCollection() {
      try {
        this.$message.closeAll();
        let token = localStorage.getItem("token");
        let res = await this.$api.cancelCollect({
          params: {
            id: this.deepread.id,
            "access-token": token,
          },
          data: {},
        });
        this.is_collect = false;
        this.$message({
          message: "取消收藏",
          type: "success",
        });
      } catch (error) {}
    },
    // 取消收藏和收藏
    collect() {
      if (this.is_collect) {
        this.cancelCollection();
      } else {
        this.collectionBooks();
      }
    },
    // 获取机构id
    async getAgencyId() {
      try {
        let res = await this.$api.getAgencyId({
          params: {
            group: "pc",
          },
          data: {},
        });
        console.log("获取机构id", res);
        // this.ogran_name = res.data.ogran_name;
        return res.data;
      } catch (error) {}
    },
    // 处理是否获取到id
    async handleAgencyId() {
      try {
        if (this.$route.params.id) {
          this.agencyId = this.$route.params.id;
          // localStorage.setItem('ogran_id',this.$route.params.id)
          return this.$route.params.id;
        } else {
          // 判断缓存中是否有
          let id = localStorage.getItem("ogran_id");
          if (id) {
            // this.agencyId = id;
            return id;
          } else {
            // 缓存中没有就根据ip获取
            let res = await this.getAgencyId();
            return res.ogran_id;
          }
        }
      } catch (error) {}
    },
    // 跳转获奖作品
    navToAwardWork() {
      let index = this.activityNavs.findIndex((item) => {
        return item.isActive;
      });
      console.log("aaaa", index);
      // return;
      this.$router.push({ path: "/awardWorks", query: { activeIndex: index } });
    },
    // 获取菜单的权限
    async getMenu(ogran_id) {
      try {
        let res = await this.$api.getExpendMenu({
          data: {
            ogran_id: ogran_id,
          },
          params: {
            group: "pc",
          },
        });
        console.log("菜单", res);
        return res.data;
      } catch (error) {
        return error;
      }
    },
    // 跳转页面并验证 是否有权限
    navToByValit(data) {
      console.log("参数", data, this.authority);
      let auth = false;
      switch (data.path) {
        case "/deepread":
          auth = this.authority.includes("深度阅读") ? true : false;
          break;
        case "/postbook":
          auth = this.authority.includes("深度阅读") ? true : false;
          break;
        case "/greenwritedetail":
          auth = this.authority.includes("青青写") ? true : false;
          break;
        case "/":
          auth = this.authority.includes("青青听") ? true : false;
          break;
        case "/knowingdetail":
          auth = this.authority.includes("有知") ? true : false;
          break;
        case "/notedetail":
          auth = this.authority.includes("视频讲堂") ? true : false;
          break;
      }
      if (auth) {
        let routeData = this.$router.resolve(data);
        window.open(routeData.href, "_blank");
      } else {
        this.$message.closeAll();
        this.$message({
          // message: "暂无权限",
          message: "暂无权限,请与图书馆联系",
          offset: 400,
          type:'warning'
        });
      }

      return;
    },
  },
  created() {
    this.getUrl();
    this.handleAgencyId().then((res) => {
      console.log("create==============", res);
      this.organ_id = res;
      localStorage.setItem("ogran_id", res);
      // // 判断是否有机构id有则获取本馆活动，没有则其他活动
      if (res) {
        this.getActivitybyOur(1, 3);
      } else {
        this.getActivitybyOther(1, 3);
        this.$nextTick((res) => {
          // console.log('其他活动');
          this.navChange(1);
        });
      }
      this.getHome(res);
      this.getMenu(res).then((res) => {
        console.log("---end", res);
        let authority = [];
        for (let el of res) {
          if (el.is_legal) {
            authority.push(el.title);
          }
        }
        this.authority = authority;
      });
    });
  },
  mounted() {
    if (localStorage.getItem("ogran_id")) {
      this.$data.activeName = "first";
    }
  },
};
</script>
<style lang="less" scoped>
@green: #3370ff;
@gray: #999;
@orange: #ffb463;
@base_color: #f8f8f8;
.home {
  background-color: @base_color;
  .deepread-wrap {
    height: 543px;
    background-image: url("../../assets/images/banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    &-container {
      width: 1200px;
      margin: 0 auto;
      padding-top: 40px;
      .deepread-main {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-cover {
          width: 272px;
          height: 360px;
          border-radius: 10px;
          .cover-img {
            border-radius: 10px;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
        &-content {
          width: 350px;
          &-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 30px;
          }
          .author {
            color: @gray;
            margin-bottom: 19px;
            font-size: 14px;
          }
          .intro {
            font-size: 12px;
            margin-bottom: 40px;
            line-height: 22px;
            height: 110px;
            color: @gray;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
          }
          .nav {
            font-size: 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 40px;
            &-item {
              // flex: 1;
              cursor: pointer;
              font-size: 4px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              color: #3370ff;
              &-img {
                width: 26px;
                height: 26px;
                margin-right: 9px;
              }
              &-name {
                font-size: 12px;
              }
            }
            .tag {
              width: 1px;
              height: 15px;
              background-color: #beebb8;
            }
          }
          &-btns {
            display: flex;
            align-items: center;
            .btn {
              margin-left: 20px;
              font-size: 12px;
            }
            .btn_style{
              background-color: #3370ff;
            }
          }
        }
        &-sidebar {
          width: 340px;
          font-size: 14px;
          .sidebar-title {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: @green;
            margin-bottom: 20px;
            .hot {
              width: 30px;
              height: 30px;
            }
            .title-text {
              font-size: 14px;
              white-space: nowrap;
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .more {
              font-size: 15px;
              cursor: pointer;
            }
          }
          .sidebar-content {
            height: calc(300px);
            overflow: hidden;
            &-row {
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              line-height: 1.5;
              margin-bottom: 20px;
              .name {
                color: @green;
              }
            }
            .none {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              background: #f8f8f8;
              font-size: 15px;
            }
          }
        }
      }
    }
  }
  &-container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
    .activity {
      margin-top: 40px;
      .nav {
        height: 60px;
        display: flex;
        align-items: center;
        position: relative;
        --navx: 0;
        &::after {
          content: "";
          display: block;
          width: 100px;
          height: 10px;
          background-color: #3370ff;
          position: absolute;
          left: 0;
          bottom: 1px;
          border-radius: 10px;
          transform: translateX(calc(1px * var(--navx)));
          transition: transform 0.3s linear;
        }
        .awardwork {
          display: flex;
          margin-right: 30px;
          font-size: 14px;
          // width: 110px;
          height: 35px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #3370ff;
          color: #3370ff;
          border-radius: 30px;
          cursor: pointer;
          .icon {
            width: 20px;
            height: 20px;
            margin-right: 2px;
          }
          .text{
            font-size: 14px;
          }
        }
        &-item {
          cursor: pointer;
          margin-right: 50px;
          font-size: 26px;
          font-weight: bold;
          position: relative;
          &_gray {
            color: @gray;
          }
          &_green {
            color: #333;
          }
        }
        &-subtitle {
          color: #999;
          font-size: 18px;
        }
      }
      &-main {
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        // overflow: hidden;
        // flex-wrap: wrap;
        .item {
          margin-right: 30px;
          &:last-child {
            margin-right: auto;
          }
        }
      }
    }
    .newwords {
      margin-top: 60px;
      &-list {
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-item {
          margin-right: 52px;
          &:last-child {
            margin-right: auto;
          }
        }
      }
    }
    .lecture {
      margin-top: 40px;
      &-list {
        display: flex;
        align-items: center;
        margin-top: 30px;
        &-item {
          margin-right: 32px;
          &:last-child {
            margin-right: auto;
          }
        }
      }
    }
    .newvoice {
      margin-top: 40px;
      &-list {
        display: flex;
        align-items: center;
        margin-top: 30px;
        &-item {
          margin-right: 52px;
          &:last-child {
            margin-right: auto;
          }
        }
      }
    }
    .knowledge {
      margin-top: 40px;
      &-list {
        display: flex;
        flex-direction: column;
        // align-items: center;
        margin-top: 30px;
        &-item {
          margin-top: 20px;
          // margin-right: 52px;
          &:last-child {
            // margin-right: auto;
          }
        }
      }
    }
    .active-origanizer {
      margin-top: 40px;
      .list {
        margin-top: 38px;
      }
    }
  }
}

@media screen and (max-width: 1400px) and (min-width: 200px) {
}
 .el-tabs .tab-pane{
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue